<script setup lang="ts">
import CreateAndDeleteButtons from "@/components/AllowAccessOfficeParts/createOrDeleteButtons/CreateAndDeleteButtons.vue"
import getOperationOffice from "@/types/responses/getOperationOffice"
import getAllowAccessOfficeResponse from "@/types/responses/getAllowAccessOffice"
import {
  SELECTABLE_STATUSES,
  ALL,
  COMPLETED,
  INCOMPLETED
} from "@/services/consts/allow_access_office";

type keyValue = {
  key: string | number,
  value: string | number
}

const emits = defineEmits(['inactiveModal'])
const props = defineProps<{
  allowAccessOffices: getAllowAccessOfficeResponse[]
  account: any
  operationOffices: getOperationOffice[]
  createAuthority: boolean
  deleteAuthority: boolean
  selectedStatusKey: keyValue
}>()

function filterAllowAccessOffice(operationOffice: getOperationOffice) {
  return props.allowAccessOffices.filter((allowAccessOffice) => {
    return allowAccessOffice.operation_office_id == operationOffice.id
  })
}

function filterByStatus(operationOffice: getOperationOffice) {
  if (props.selectedStatusKey.value == ALL) {
    return true
  }

  const exists: number = filterAllowAccessOffice(operationOffice).length
  if ((props.selectedStatusKey.value == COMPLETED && exists) ||
    (props.selectedStatusKey.value == INCOMPLETED && !exists)
  ) {
    return true
  }

  return false
}

function inactiveModal(isSucceeded: boolean) {
  emits('inactiveModal', isSucceeded)
}
</script>
<template>
  <v-table class="border">
    <tbody>
      <tr v-for="(operationOffice, index) in props.operationOffices" :key="index">
        <template v-if="filterByStatus(operationOffice)">
          <td>{{ operationOffice.name }}</td>
          <td class="pr-2">
            <CreateAndDeleteButtons
              :accountId="props.account.id"
              :operationOfficeId="operationOffice.id"
              :allowAccessOffice="filterAllowAccessOffice(operationOffice)"
              :createAuthority="props.createAuthority"
              :deleteAuthority="props.deleteAuthority"
              @inactiveModal="inactiveModal"
            />
          </td>
        </template>
      </tr>
    </tbody>
  </v-table>
</template>